import React, { useCallback } from 'react'
import { Text } from '@usap/uicomponents'
import {
  OrderDetailsBlueButton,
  OrderDetailsButtonContainer,
} from './style/button.css'

const Default = ({ data }) => {
  const {
    showReturn,
    navigateToRMA,
    partNumber,
    orderId,
  } = { ...data }

  const actionButtonClick = useCallback(() => {
    navigateToRMA(orderId, partNumber)
  }, [orderId, partNumber, navigateToRMA])

  return (
    showReturn && (
      <OrderDetailsButtonContainer>
        <OrderDetailsBlueButton
          custom
          hideBorder
          onClick={actionButtonClick}
          label={<Text size="small">Return Item</Text>}
        />
      </OrderDetailsButtonContainer>
    )
  )
}

export default Default
